import queryString from "query-string";
import { FilterParams } from "../types/types";

export const getFiltersFromUrl = (): Partial<FilterParams> => {
  const parsed = queryString.parse(window.location.search);

  const filters: Partial<FilterParams> = {
    countOnPage: parsed.countOnPage ? Number(parsed.countOnPage) : 100,
    page: (parsed.page as string) || "1",
    product: (parsed.product as string) || "all",
    q: (parsed.q as string) || "",
    sort: parsed.sort ? Number(parsed.sort) : 0, // Изменено с 1 на 0
    city: parsed.city ? Number(parsed.city) : 0,
  };

  return filters;
};

export const updateUrlWithFilters = (filters: FilterParams) => {
  // Создаем объект только с непустыми значениями
  const cleanFilters: any = {};

  // Добавляем только значения, отличные от дефолтных
  if (filters.countOnPage !== 100)
    cleanFilters.countOnPage = filters.countOnPage;
  if (filters.page !== "1") cleanFilters.page = filters.page;
  if (filters.product !== "all") cleanFilters.product = filters.product;
  if (filters.q) cleanFilters.q = filters.q; // Добавляем только если не пустой
  if (filters.sort !== 0) cleanFilters.sort = filters.sort; // Изменено с 1 на 0
  if (filters.city !== 0) cleanFilters.city = filters.city;

  const params = queryString.stringify(cleanFilters, { skipEmptyString: true });
  const newUrl = `${window.location.pathname}${params ? "?" + params : ""}`;

  // Используем replaceState чтобы не создавать лишние записи в истории
  window.history.replaceState({}, "", newUrl);
};

// Функция для получения полной ссылки с параметрами
export const getShareableUrl = (): string => {
  return window.location.href;
};
